export default {
    title: 'Emplacements',
    subtitle: 'Liste des emplacements',
    createLocation: 'Créer un Emplacement',
    createSubtitle: 'Ajouter un nouvel emplacement pour suivre le placement des ressources',
    editLocation: 'Modifier l\'Emplacement',
    editTitle: 'Modifier l\'Emplacement',
    editSubtitle: 'Mettre à jour les informations de l\'emplacement',
    createSuccess: 'Emplacement créé avec succès',
    createError: 'Échec de la création de l\'emplacement',
    updateSuccess: 'Emplacement mis à jour avec succès',
    updateError: 'Échec de la mise à jour de l\'emplacement',
    loadError: 'Échec du chargement de l\'emplacement',
    notFound: 'Emplacement introuvable',
    locationForm: {
        name: 'Nom de l\'Emplacement',
        nameRequired: 'Le nom de l\'emplacement est requis',
        nameMinLength: 'Le nom de l\'emplacement ne peut pas être vide',
        namePlaceholder: 'Entrez le nom de l\'emplacement',
        description: 'Description',
        descriptionPlaceholder: 'Entrez la description de l\'emplacement',
        notes: 'Notes',
        notesPlaceholder: 'Notes supplémentaires à propos de cet emplacement'
    },
    locationsAdmin: {
        createTitle: 'Créer un Emplacement',
        editTitle: 'Modifier l\'Emplacement',
        deleteTitle: 'Supprimer l\'Emplacement',
        createSuccess: 'Emplacement créé avec succès',
        updateSuccess: 'Emplacement mis à jour avec succès',
        deleteSuccess: 'Emplacement supprimé avec succès',
        createError: 'Échec de la création de l\'emplacement',
        updateError: 'Échec de la mise à jour de l\'emplacement',
        deleteError: 'Échec de la suppression de l\'emplacement',
        deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cet emplacement ? Cette action est irréversible.'
    }
};
